import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { closeCenteredModal } from "../../REDUX/actions/centeredModal";
import Select from "../Common/FormElements/Select/Select";
import Button from "../Common/FormElements/Button/Button";
import { useDispatch } from "react-redux";
import { updateAvoirStatus } from "../../REDUX/actions/avoir";

const UpdateStatusDialog = ({ id, status, number }) => {
  const { t } = useTranslation("common");
  const dispatch = useDispatch();
  const [selectedStatus, setSelectedStatus] = useState(
    status
      ? {
          name: t(`${status}`),
          code: status,
        }
      : {}
  );

  const handleSubmit = () => {
    dispatch(updateAvoirStatus(id, selectedStatus.code, t));

    dispatch(closeCenteredModal());
  };

  return (
    <div>
      <p className="f15 sBold">
        {t("Credit status")} #{number} :
      </p>
      <Select
        options={[
          {
            name: t("To refund"),
            code: "To refund",
          },
          {
            name: t("Completed"),
            code: "Completed",
          },
        ]}
        placeholder={t("Select")}
        value={selectedStatus}
        callback={(e) => setSelectedStatus(e.value)}
        className="mb-4"
      />
      <div className="d-flex justify-content-center gap-3">
        <Button onClick={handleSubmit}>{t("Save")}</Button>
        <Button onClick={() => dispatch(closeCenteredModal())}>
          {t("Cancel")}
        </Button>
      </div>
    </div>
  );
};

export default UpdateStatusDialog;
